import { rangeWithDefaultsWhenEmpty } from '../engine/default-handlers';
import { defineFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

const DEFAULT_MIN_HIRING_RATE = 0;
const DEFAULT_MAX_HIRING_RATE = 25;

export const hiringRateDescriptor = defineFilter({
  definition: {
    id: FilterId.HIRING_RATE,
    name: 'Hiring Rate',
    type: FilterType.RANGE,
    min: DEFAULT_MIN_HIRING_RATE,
    max: DEFAULT_MAX_HIRING_RATE,
    isActive: false,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_HIRING_RATE, segmented: true },
  handler: rangeWithDefaultsWhenEmpty(
    DEFAULT_MIN_HIRING_RATE,
    DEFAULT_MAX_HIRING_RATE
  ),
});
